import Vue from 'vue'
import App from './App.vue'
// 関連Libインポート
import vuetify from './plugins/vuetify'
import veeValidate from "./plugins/vee-validate"
import vueLoading from "./plugins/vue-loading"
import vuejsDatepicker from "./plugins/vuejs-datepicker"
// import vueSelectSides from "./plugins/vue-select-sides"
import router from './router'
import store from './store'
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getFunctions } from "firebase/functions";

Vue.config.productionTip = false

// firebase初期設定
// TODO 環境により変更が必要なため一生残しておくTODO
const firebaseConfig = {
  apiKey: "AIzaSyA9OW4sDd9XedfRkLauEbp8S3rhH6vE5Ro",
  authDomain: "schoolaid-support.firebaseapp.com",
  projectId: "schoolaid-support",
  storageBucket: "schoolaid-support.appspot.com",
  messagingSenderId: "1041247757197",
  appId: "1:1041247757197:web:11e6bbef853290f23953c4"
};
const version = 'ver 1.0.000';
const copyright = '©Canon Electronics Technology Inc.';

const firebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebase);
const functions = getFunctions(firebase);
functions.region = "asia-northeast1";

// validateを各種画面にて使用できるようにする
Vue.mixin(veeValidate)
Vue.mixin(vueLoading)
Vue.mixin(vuejsDatepicker)
Vue.config.devtools = true;

new Vue({
  data: {
    isLogin: false,
    loading: false,
    siteName: "",
    version: version,
    copyright: copyright,
  },
  vuetify,
  router,
  store,
  firebase,
  functions,
  analytics,
  render: h => h(App)
}).$mount('#app')
